'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validGeneralUrlPathChars = require('./validGeneralUrlPathChars');

var _validGeneralUrlPathChars2 = _interopRequireDefault(_validGeneralUrlPathChars);

var _validUrlBalancedParens = require('./validUrlBalancedParens');

var _validUrlBalancedParens2 = _interopRequireDefault(_validUrlBalancedParens);

var _validUrlPathEndingChars = require('./validUrlPathEndingChars');

var _validUrlPathEndingChars2 = _interopRequireDefault(_validUrlPathEndingChars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Allow @ in a url, but only in the middle. Catch things like http://example.com/@user/
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validUrlPath = (0, _regexSupplant2.default)('(?:' + '(?:' + '#{validGeneralUrlPathChars}*' + '(?:#{validUrlBalancedParens}#{validGeneralUrlPathChars}*)*' + '#{validUrlPathEndingChars}' + ')|(?:@#{validGeneralUrlPathChars}+/)' + ')', {
  validGeneralUrlPathChars: _validGeneralUrlPathChars2.default,
  validUrlBalancedParens: _validUrlBalancedParens2.default,
  validUrlPathEndingChars: _validUrlPathEndingChars2.default
}, 'i');

exports.default = validUrlPath;
module.exports = exports['default'];